import { Checkmark } from '@carbon/icons-react';
import React from 'react';

import {
  Combobox,
  ComboboxContent,
  ComboboxGroup,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
  ComboboxTrigger,
} from 'DesignSystem/features/combobox';
import LongText from 'components/LongText';

export function DefaultSelectFilter(
  props: React.PropsWithChildren<{
    value: string | null;
    name: string;
    options: Array<{ label: React.ReactNode; value: string; keywords?: Array<string> }>;
  }> &
    Pick<React.ComponentProps<typeof Combobox>, 'onOpenChange'> &
    Pick<React.ComponentProps<typeof ComboboxItem>, 'onSelect'> &
    Pick<React.ComponentProps<typeof ComboboxInput>, 'onInput'> &
    Pick<React.ComponentProps<typeof ComboboxContent>, 'shouldFilter'>
) {
  return (
    <Combobox onOpenChange={props.onOpenChange}>
      <ComboboxTrigger asChild>{props.children}</ComboboxTrigger>
      <ComboboxContent align="start" className="min-w-min" shouldFilter={props.shouldFilter}>
        <ComboboxInput onInput={props.onInput} />
        <ComboboxGroup>
          <ComboboxList>
            {props.options.map((option) => (
              <ComboboxItem
                key={option.value}
                value={option.value}
                onSelect={props.onSelect}
                className="group w-full justify-between gap-4"
                data-active={props.value === option.value}
                keywords={option.keywords}
              >
                {typeof option.label === 'string' ? <LongText text={option.label} /> : option.label}
                <Checkmark className="size-4 shrink-0 group-data-[active=false]:opacity-0 group-data-[active=true]:opacity-100" />
              </ComboboxItem>
            ))}
          </ComboboxList>
        </ComboboxGroup>
      </ComboboxContent>
      {props.value ? <input type="hidden" name={props.name} value={props.value} /> : null}
    </Combobox>
  );
}
